<template>
  <div class="search-item">
    <div class="address-information">
      <span class="name">{{ fullname }}</span>
      <span>{{ addressLine }}</span>
      <span>{{ cityLine }}</span>
    </div>
    <div class="contact-information">
      <span>{{ email }}</span>
      <span>{{ phoneNumber }}</span>
    </div>
    <div class="actions-container">
      <button class="phone">
        <PhoneIcon/>
      </button>
      <button class="info" @click="$emit('openPopup', popupData)">
        <InfoIcon/>
      </button>
    </div>
  </div>
</template>

<script>
import {InfoIcon, PhoneIcon} from "vue-feather-icons";

export default {
  components: {
    PhoneIcon,
    InfoIcon
  },

  props: {
    data: Object,
	  popupData: Object
  },

  data() {
    return {};
  },
  computed: {
    addressLine () {
      const address = this.data.visitingaddress_street + ' ' + this.data.visitingaddress_streetnumber;
      return address.trim() !== '' ? address : 'Straat niet bekend';
    },

    cityLine() {
      const city = this.data.visitingaddress_zipcode + ' ' + this.data.visitingaddress_city;
      return city.trim() !== '' ? city : 'Stad niet bekend';
    },

    email() {
      return this.data.email != null && this.data.email.trim() !== '' ? this.data.email : 'Email niet bekend';
    },

    phoneNumber() {
      if (this.data.phone) {
        return this.data.phone;
      } else if (this.data.mobile) {
        return this.data.mobile;
      } else {
        return 'Telefoonnummer niet bekend';
      }
    },

    fullname() {
      const salutations = {
        1: "Dhr.",
        2: "Mevr.",
        3: "Dhr/Mevr."
      };

      let name = [];
      if (this.data.salutation != null && this.data.salutation !== "") name.push(salutations[parseInt(this.data.salutation)]);
      if (this.data.initials != null && this.data.initials !== "") name.push(this.data.initials);
      if (this.data.infix != null && this.data.infix !== "") name.push(this.data.infix);
      if (this.data.lastname != null && this.data.lastname !== "") name.push(this.data.lastname);
      if (name.length === 0) name.push(this.data.companyname);

      return name.join(" ");
    }
  },
  methods: {}
};
</script>
